import { render, staticRenderFns } from "./IconSegmentSave.vue?vue&type=template&id=94080b0c&"
import script from "./IconSegmentSave.vue?vue&type=script&lang=js&"
export * from "./IconSegmentSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94080b0c')) {
      api.createRecord('94080b0c', component.options)
    } else {
      api.reload('94080b0c', component.options)
    }
    module.hot.accept("./IconSegmentSave.vue?vue&type=template&id=94080b0c&", function () {
      api.rerender('94080b0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconSegmentSave.vue"
export default component.exports